import { iconFactory } from '../iconFactory'

export const Location = iconFactory(
  'Location',
  ({ fill }) => (
    <path
      d="M10.4994 1.6665C7.27435 1.6665 4.66602 4.27484 4.66602 7.49984C4.66602 8.94984 5.08268 10.3082 5.84102 11.5332C6.63268 12.8165 7.67435 13.9165 8.47435 15.1998C8.86602 15.8248 9.14935 16.4082 9.44935 17.0832C9.66602 17.5415 9.84102 18.3332 10.4994 18.3332C11.1577 18.3332 11.3327 17.5415 11.541 17.0832C11.8494 16.4082 12.1244 15.8248 12.516 15.1998C13.316 13.9248 14.3577 12.8248 15.1494 11.5332C15.916 10.3082 16.3327 8.94984 16.3327 7.49984C16.3327 4.27484 13.7244 1.6665 10.4994 1.6665ZM10.4994 9.7915C9.34935 9.7915 8.41602 8.85817 8.41602 7.70817C8.41602 6.55817 9.34935 5.62484 10.4994 5.62484C11.6494 5.62484 12.5827 6.55817 12.5827 7.70817C12.5827 8.85817 11.6494 9.7915 10.4994 9.7915Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 20 20', height: '20px', width: '20px' },
)
